import { Chip } from 'src/shared/design-system/Chip';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { BorderRadius, Colors, Font, Spacing } from 'web-common/src/shared/styles';
import { DynamicImage } from '../DynamicImage';

export const IMAGE_WIDTH = 238;
export const IMAGE_HEIGHT = 160;

const sharedContainerStyles = `
font-family: ${Font.Family.SANS};
position: relative;
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0;

width: 240px;
height: ${(props) => props.height ?? '368px'};

background: ${Colors.WHITE};

border: 1px solid ${Colors.GRAY_LITE_30};
border-radius: ${BorderRadius.M};

-webkit-tap-highlight-color: transparent;

&:focus {
  text-decoration: none;
}
`;

export const ClickableContainer = styled.a<{ height?: string }>`
  ${sharedContainerStyles}
  cursor: pointer;
`;

export const DefaultContainer = styled.div<{ height?: string }>`
  ${sharedContainerStyles}
`;

export const ImageHeader = styled.div`
  position: relative;
  max-height: ${IMAGE_HEIGHT}px;
  width: ${IMAGE_WIDTH}px;
  flex-shrink: 0;
  overflow: hidden;
`;

export const ChipContainer = styled.div<{ top?: boolean; bottom?: boolean; left?: boolean; right?: boolean }>`
  position: absolute;
  ${({ top, bottom }) =>
    top && !bottom
      ? css`
          top: ${Spacing.HALF};
        `
      : css`
          bottom: ${Spacing.HALF};
        `}

  ${({ left, right }) =>
    left && !right
      ? css`
          left: ${Spacing.HALF};
        `
      : css`
          right: ${Spacing.HALF};
        `}
`;

export const DishBody = styled.div`
  display: flex;
  flex-direction: row;
  flex-direction: column;
  box-sizing: border-box;
  flex-grow: 1;
  width: 100%;
  max-width: 100%;
  padding: ${Spacing.THREE_QUARTERS} ${Spacing.THREE_QUARTERS} ${Spacing.QUARTER} ${Spacing.THREE_QUARTERS};

  font-family: ${Font.Family.SANS};
  font-size: ${Font.Size.XS};
  font-weight: ${Font.Weight.MEDIUM};
`;

export const DishFooter = styled.div<{ useGrayBackground?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 0 ${Spacing.THREE_QUARTERS} ${Spacing.THREE_QUARTERS} ${Spacing.THREE_QUARTERS};

  ${({ useGrayBackground }) =>
    useGrayBackground
      ? css`
          background-color: #f5f5f5;
        `
      : null}
`;

export const DishFooterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const DishFirstCardImage = styled(DynamicImage)`
  width: 100%;
  border-radius: ${BorderRadius.M} ${BorderRadius.M} 0 0;
`;

export const DishFirstCardLandscapeImage = styled(DynamicImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${BorderRadius.M} 0 0 ${BorderRadius.M};
`;

export const HorizontalRule = styled.div`
  margin-bottom: ${Spacing.THREE_QUARTERS};
  width: 100%;
  height: 0;
  border-bottom: 1px solid ${Colors.GRAY_LITE_20};
`;

export const StyledRatingChip = styled(Chip)<{ showInline: boolean }>`
  font-size: ${Font.Size.XXS};
  color: ${Colors.GRAY_DARK_30};
  background-color: ${Colors.BUTTER_100};
  font-weight: ${Font.Weight.SEMI_BOLD};
  white-space: nowrap;

  ${ifProp(
    'showInline',
    css`
      box-shadow: 0;
      margin-top: ${Spacing.QUARTER};
      margin-bottom: ${Spacing.HALF};
    `
  )}
`;

export const RatingIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  // The icon is visually weighted towards the bottom, so we need to raise it up so that it _looks_ even
  margin-top: -2px;
  align-items: center;
  margin-right: ${Spacing.QUARTER};
`;
